import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { impersonateUser } from "../../store/actions/auth.action";

export function ImpersonateUserModal({ open, close }) {
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username.trim()) return;

    setLoading(true);
    dispatch(impersonateUser(username.trim()))
      .finally(() => {
        setLoading(false);
        close();
      });
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl relative animate-fadeIn">
        <h2 className="text-xl font-bold text-gray-800 mb-2 flex items-center gap-2">
          <span>👤</span> Admin: Impersonate User
        </h2>
        <p className="text-sm text-gray-600 mb-4">
          Enter the username or email of the user account you want to log into.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wider mb-1">
              Username or Email
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="e.g. user@example.com"
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[var(--brand)] focus:border-transparent outline-none text-sm transition-all"
            />
          </div>

          <div className="flex items-center justify-end gap-3 mt-6">
            <button
              type="button"
              onClick={close}
              disabled={loading}
              className="px-4 py-2 rounded-xl border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !username.trim()}
              className="px-5 py-2 rounded-xl bg-[var(--brand)] text-white text-sm font-semibold hover:bg-[var(--brand-dark)] transition-colors shadow-md disabled:opacity-50"
            >
              {loading ? "Switching..." : "Impersonate"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ImpersonateUserModal;
